import styled from 'styled-components';

export const ModalContainer = styled.div`
  h2 {
    color: #096dd9;
    font-weight: 400;
    font-size: 16px;
  }

  p {
    font-size: 14px;
    color: #8c8c8c;
  }
`;
